package core.validation.validator

object NonEmptyValidator : Validator<String> {
    override val errorMessage: String
        get() = "This field is required."

    override fun validate(value: String): Boolean {
        return value.trim().isNotEmpty()
    }
}
